import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbDropdownModule, NgbModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { AssetService } from '../../../Model/AssetModule/asset.service';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { Subject } from 'rxjs';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { SessionService } from '../../../Util/Session/session.service';
import { type } from 'os';
import { CommonService } from '../../../Model/Common/common.service';

@Component({
  selector: 'app-asset-transfer-form',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule, NgbDatepickerModule, DataTablesModule, NgbDropdownModule, NgbTooltipModule],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './asset-transfer-form.component.html',
  styleUrl: './asset-transfer-form.component.scss'
})
export class AssetTransferFormComponent {
  isDisabled: boolean = false;
  user = [] as any;
  ToID = null;
  isSelected: boolean = false;

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  Employee = [] as any;
  Branch = [] as any;
  Status = [] as any;
  TableDatas = [] as any;
  AllotmentType = [{ AllotmentName: 'Assign', AllotmentValue: 'Assign' }, { AllotmentName: 'UnAssign', AllotmentValue: 'UnAssign' }]
  AssetAllotmentDetails = {
    ESS_AssetAdditionDetailsID: 0,
    TransactionType: null,
    AssignDate: null as any,
    AllotmentBranchId: null,
    AllotmentEmployeeId: null,
    AllotmentFromType: null,
    From_ID: 0,
    AllotmentToType: null as any,
    To_ID: null,
    Remark: null,
    Attachment: null as any,
    AttachmentUrl: null as any,
    AllotmentStatus: null as any,
    StatusId: null as any,
    ESS_AssetAllotment: [] as any
  }

  ESS_AssetAllotmentList = {
    ESS_AssetAllotment: [] as any
  }
  dtoptions: DataTables.Settings = {};
  constructor(
    private AssetService: AssetService,
    private modalService: NgbModal,
    private combo: ComboService,
    private toast: ToastService,
    private route: ActivatedRoute,
    private router: Router,
    public dateFormate: CustomDateParserFormatter,
    private utility: UtilityService,
    private session: SessionService,
    protected common: CommonService
  ) {
    this.user = this.session.GetUserDetails();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ComboLoad('EmployeeMaster');
    this.ComboLoad('Branch');
    this.ComboLoad('StatusMaster');
    this.LoadAssetMaster();
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
  isShow: boolean = false;
  isShow1: boolean = false;
  // Toggle1(){
  //   this.isShow =false
  //   this.isShow1=true
  // }
  // Toggle2(){
  //  this.isShow1 =false
  //  this.isShow = true
  // }
  Toggle(value: string) {
    this.AssetAllotmentDetails.AllotmentToType = value;
    if (value == 'Location') {
      this.isShow = false;
      this.isShow1 = true;
    }
    else if (value == 'Employee') {
      this.isShow1 = false;
      this.isShow = true;
    }
  }
  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    this.combo.ComboLoad({ 'Combotype': Combotype }).subscribe({
      next: (response) => {
        if (Combotype == 'EmployeeMaster') {
          this.Employee = response.ComboLoad;
        }
        else if (Combotype == 'Branch') {
          this.Branch = response.ComboLoad;
        }
        else if (Combotype == 'StatusMaster') {
          this.Status = response.ComboLoad;
        }

        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  LoadAssetMaster() {

    this.isDisabled = true;
    this.AssetService.LoadAssetAdditionDetail({ SelectType: 1, ESS_AssetAdditionId: 0 }).subscribe({
      next: (response) => {
        this.TableDatas = Object.values(response);
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  Validate(form: any) {
    console.log("enter");
    if (form.valid) {
      if (this.AssetAllotmentDetails.AllotmentToType !== 'Location' && this.AssetAllotmentDetails.AllotmentToType !== 'Employee') {
        this.toast.show({ message: 'Please select a transaction type (Location or Employee).', type: toastTypeEnum.warning });
        return; // Exit the function if no transaction type is selected
      }
      else if (this.AssetAllotmentDetails.AssignDate == null) {
        this.toast.show({ message: 'Please select a assign date.', type: toastTypeEnum.warning });
        return;
      }
      else if (this.AssetAllotmentDetails.AllotmentToType == 'Location') {
        if (this.AssetAllotmentDetails.AllotmentBranchId == null) {

          this.toast.show({ message: 'Please select a branch ', type: toastTypeEnum.warning });
          return;
        }
      }
      else if (this.AssetAllotmentDetails.AllotmentToType == 'Employee') {
        if (this.AssetAllotmentDetails.AllotmentEmployeeId == null) {

          this.toast.show({ message: 'Please select a employee ', type: toastTypeEnum.warning });
          return;
        }
      }

      this.AssetAllotmentInsertUpdate();


    }
    else {
      form.submitted = true;
    }
  }
  AssetAllotmentInsertUpdate() {
    const selectedAssets = this.TableDatas.filter((asset: any) => asset.isSelected);

    if (!selectedAssets || selectedAssets.length === 0) {
      this.toast.show({ message: 'Please select at least one asset to allot.', type: toastTypeEnum.warning });
      return; // Exit the function if no asset is selected
    }

    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to save?';
    modalRef.result.then(result => {
      if (result) {

        if (this.AssetAllotmentDetails.AllotmentToType == 'Location') {
          this.ToID = this.AssetAllotmentDetails.AllotmentBranchId;
        }
        else if (this.AssetAllotmentDetails.AllotmentToType == 'Employee') {
          this.ToID = this.AssetAllotmentDetails.AllotmentEmployeeId;
        }
        this.TableDatas.forEach((element: any) => {
          if (element.isSelected) {
            this.ESS_AssetAllotmentList.ESS_AssetAllotment.push({
              ESS_AssetAdditionDetailsID: 0,
              TransactionType: "Allotment",
              AssignDate: this.dateFormate.format(this.AssetAllotmentDetails.AssignDate),
              AllotmentBranchId: this.AssetAllotmentDetails.AllotmentBranchId,
              AllotmentFromType: "Branch",
              From_ID: element.BranchId,
              To_ID: this.ToID,
              AllotmentToType: this.AssetAllotmentDetails.AllotmentToType,
              Remark: this.AssetAllotmentDetails.Remark,
              Attachment: this.AssetAllotmentDetails.Attachment,
              AllotmentStatus: this.AssetAllotmentDetails.AllotmentStatus,
              StatusId: this.AssetAllotmentDetails.StatusId,
            })
          }
        })
        this.isDisabled = true;
        console.log(this.ESS_AssetAllotmentList);

        this.AssetService.InsertUpdateAssetTransfer(this.ESS_AssetAllotmentList).subscribe({
          next: (response) => {
            if (response.Error_Code == '01') {
              this.router.navigate(['/Asset/assetTransfer/']);
              this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
            } else {
              this.toast.show({ message: response.Error_Message, type: toastTypeEnum.danger });
            }
            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }
    });
  }
  upload(event: any, Folder: any) {
    try {
      this.isDisabled = true;
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.utility.Upload({ 'DomainName': this.user.Domain, 'folder': Folder, 'CompanyCode': this.user.CompanyCode, 'FileBase64': reader.result }).subscribe((response: any) => {
          if (response.FileName != "") {
            this.AssetAllotmentDetails.Attachment = response.FileName;
            this.AssetAllotmentDetails.AttachmentUrl = response.Url;
          } else {
            this.toast.show({ message: 'Image not uploaded', type: toastTypeEnum.danger });
          }
          this.isDisabled = false;
        }, (error) => {
          this.isDisabled = false;
        });
      };
    } catch (e) { }
  }
}
